import htmlTemplate from './transaction-information.directive.html';
import _ from 'underscore';

(function() {
    "use strict";

    angular.module("cardspotWeb.areas.hvtRequest")
        .directive("emlTransactionInformation", configDirective);

    function configDirective() {
        return {
            restrict: "E",
            scope: {
                programHvtLimits:"=",
                transactionInformation:"=",
                transactionInformationComplete:"=",
                requestType:"=",
                previousStep:"="
            },
            controller: TransactionInformationController,
            controllerAs: "model",
            template: htmlTemplate
        };
    }

	TransactionInformationController.$inject = ["$q", "$scope", "$rootScope", "$translate", "SF_EVENTS", "limitService", 
        "hvtRequestService", "HVT_REQUEST_TYPES", "activationService", "notify"];

	function TransactionInformationController($q, $scope, $rootScope, $translate, SF_EVENTS, limitService, 
        hvtRequestService, HVT_REQUEST_TYPES, activationService, notify) {
        var model = this,
            cardAmountMaster = { quantity: null, amount: null },
            paymentMaster = { paymentType: null, amount: null };

        model.programName;
        model.hvtTransactionMinimum;
        model.hvtBankApprovalLimit;
        model.addCard = addCard;
        model.removeCard = removeCard;
        model.cardAmountChanged = cardAmountChanged;
        model.addPayment = addPayment;
        model.removePayment = removePayment;
        model.paymentAmountChanged = paymentAmountChanged;
        model.cardQuantityChanged = cardQuantityChanged;
        model.nextButtonEnabled = nextButtonEnabled;
        model.nextEnabled = false;
        model.selectedPayment = {
			amount: undefined,
			paymentType: undefined
		};
        model.transactionInfoIsValid = transactionInfoIsValid;
        $scope.forms = {};

        $rootScope.$on(SF_EVENTS.PROGRAM_SELECTED, handleProgramSelectedChange);
        $rootScope.$on(SF_EVENTS.HVT_REQUEST_SUCCEEDED, handleRequestSucceeded);
        $scope.isTrailingSymbol = $rootScope.isTrailingSymbol;
        $scope.currencySeparators = $rootScope.currencySeparators;
        $scope.fractionSize = $rootScope.fractionSize;

        init();

        function init() {
            model.hvtTransactionMinimum = limitService.getHVTMinimumLimit();
            model.hvtBankApprovalLimit = limitService.getHVTBankApprovalLimit();
            model.cardMaximumExemptionMaximumLimit = limitService.getCardMaximumExemptionMaximumLimit();
            initTransactionInfo();
            getPaymentTypes();
        }

        function cardAmountChanged(cardAmount) {
            calculateTransactionTotal();
            nextButtonEnabled(cardAmount);
        }

        function paymentAmountChanged(paymentAmount) {
            calculatePaymentTotal();
        }

        function cardQuantityChanged() {
            calculateTransactionTotal();
        }

        function initTransactionInfo() {
            let transactionInfo = hvtRequestService.getTransactionInformation();
            if (transactionInfo) {
                $scope.transactionInformation = transactionInfo;
            }
        }

        function getPaymentTypes() {
            activationService.getPaymentTypes().then(function (data) {
                model.paymentTypes = rejectIntegratedPaymentTypes(data, true);
            });
        }

        function handleProgramSelectedChange(event, program) {
            model.programName = program.programName;
        }

        function addCard() {
            model.nextEnabled = !model.nextEnabled;
            $scope.transactionInformation.cardAmounts.push(angular.copy(cardAmountMaster));
        }

        function removeCard(cardAmount) {
            model.nextEnabled = !model.nextEnabled;
			if (cardAmount) {
				$scope.transactionInformation.cardAmounts = _.reject($scope.transactionInformation.cardAmounts, function(aCardAmount) {
					return cardAmount.$$hashKey === aCardAmount.$$hashKey;
					});
				cardAmountChanged(cardAmount.amount);
			}
		}

        function addPayment() {
            model.nextEnabled = !model.nextEnabled;
            $scope.transactionInformation.payments.push(angular.copy(paymentMaster));
        }

        function removePayment(payment) {
            model.nextEnabled = !model.nextEnabled;
            if (payment) {
                $scope.transactionInformation.payments = _.reject($scope.transactionInformation.payments, function(aPayment) {
                    return payment.$$hashKey === aPayment.$$hashKey;
                });
                paymentAmountChanged(payment.amount);
            }
        }

        function rejectIntegratedPaymentTypes(allPaymentTypes, filterPaymentTypes) {
            var filteredPayments = _.reject(allPaymentTypes, function (paymentType) {
                return paymentType.isAuthorizable === true;
            });

            if (filterPaymentTypes) {
                return _.filter(filteredPayments, function (paymentType) {
                    if ($scope.requestType && $scope.requestType === HVT_REQUEST_TYPES.CONSUMER) {
                        return paymentType.allowedByAmlForConsumer === true;
                    } else {
                        return paymentType.allowedByAmlForCorporate === true;
                    }
                });
            }

            return filteredPayments;
        }

        function nextButtonEnabled(cardAmount) {
            var enabled = false;

            if (cardAmount >= model.cardMaximumExemptionMaximumLimit.limit) {
                enabled = true;
            }

            if ($scope.transactionInformation.totalTransactionValue - $scope.transactionInformation.totalPaymentValue === 0) {
                enabled = true;
            }

            model.nextEnabled = enabled;
        }

        function calculateTransactionTotal() {
            let total = 0;
            let numberOfCards = 0;
            angular.forEach($scope.transactionInformation.cardAmounts, function (item) {
                total += item.quantity * item.amount;
                numberOfCards += item.quantity;
            });

            $scope.transactionInformation.numberOfCards = numberOfCards;
            $scope.transactionInformation.totalTransactionValue = total;
        }

        function calculatePaymentTotal() {
            let total = 0;
            angular.forEach($scope.transactionInformation.payments, function (payment) {
                total += payment.amount;
            });

            $scope.transactionInformation.totalPaymentValue = total;
        }

        function transactionInfoIsValid() {
            let isValidHVT = false;
            let paymentsMatchTotal = false;
            
            if (($scope.transactionInformation.totalTransactionValue ?? 0) > model.hvtBankApprovalLimit.limit) {
                isValidHVT = true;
            } else if (($scope.transactionInformation.totalTransactionValue ?? 0) <= model.hvtBankApprovalLimit.limit) {
                $scope.transactionInformation.cardAmounts.forEach(ca => {
                    if ((ca.amount ?? 0) > model.cardMaximumExemptionMaximumLimit.limit)
                        isValidHVT = true;
                })
            }

            if ($scope.transactionInformation.totalTransactionValue - $scope.transactionInformation.totalPaymentValue === 0)
                paymentsMatchTotal = true;

            return $scope.forms.transactionInfoForm.$valid && isValidHVT && paymentsMatchTotal;
        }

        function handleRequestSucceeded() {
            $scope.forms.transactionInfoForm.$setPristine();
        }
    }
}());